import { FORMAT } from 'constants/date-constants';
import dayjs from 'dayjs';
import { MergeArgs } from 'pages/Order/Order.types';
import { RequestedOrderProductFragmentFragment } from 'data/__generated__';

export function mergeProductsAndProductsRequested({
    products,
    productRequestedWithQuantities,
    deliveryDate,
}: MergeArgs): RequestedOrderProductFragmentFragment[] {
    if (dayjs(deliveryDate, FORMAT).isBefore('2021-10-19')) {
        return [...products];
    }
    const updatedProducts = products.map((product) => {
        const requestedProduct = productRequestedWithQuantities.find((p) => p._id === product._id);

        if (requestedProduct) {
            const { quantityRequested } = requestedProduct;
            const portion =
                typeof product.portion === 'number' && typeof product.quantity === 'number'
                    ? (quantityRequested ?? 0) * (product.portion / product.quantity)
                    : 0;
            return {
                ...product,
                quantity: quantityRequested,
                portion,
                price: (quantityRequested ?? 0) * (product.unitPrice ?? 0),
            };
        } else {
            return product;
        }
    });
    const productsCompletelyRemovedFromProducts = productRequestedWithQuantities.filter(
        (product) => !products.some((p) => p._id === product._id),
    );
    productsCompletelyRemovedFromProducts.forEach(({ quantityRequested, ...product }) => {
        updatedProducts.push({
            ...product,
            price: (product.unitPrice ?? 0) * (quantityRequested ?? 0),
            quantity: quantityRequested,
            quantityPicked: 0,
        });
    });
    return updatedProducts;
}
